import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Box from '@mui/material/Box';
import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import {ModalsManager, Navigation} from '../components';
import AddCustomer from '../pages/AddCustomer';
import Admins from '../pages/Admins';
import AdminDetails from '../pages/AdminDetails';
import Complexes from '../pages/Complexes';
import ComplexDetails from '../pages/ComplexDetails';
import Customers from '../pages/Customers';
import CustomerDetails from '../pages/CustomerDetails';
import Dashboard from '../pages/Dashboard';
import Entrances from '../pages/Entrances';
import EntranceDetails from '../pages/EntranceDetails';
import Reports from '../pages/Reports';
import api from '../api/api';
import {getMyProfile} from '../actions';
import ElevatorsDetails from '../pages/ElevatorsDetails';
import ElevatorConfigurations from '../pages/ElevatorConfiguration';
import CardDetails from '../pages/CardDetails';
import AddCard from '../pages/AddCard';
import Profile from '../pages/Profile';
import Services from '../pages/Services/Services';
import AddElevatorReport from '../pages/Services/AddElevatorReport';
import PdfViewerScreen from '../pages/Services/PDF/PdfViewerScreen';
import AddEscalatorReport from '../pages/Services/AddEscalatorReport';
import Elevators from '../pages/Elevators';
import Supervisors from '../pages/Supervisors';
import SupervisorsDetails from '../pages/SupervisorsDetails';
import ElevatorReports from '../pages/ElevatorReports';
import EscalatorReports from '../pages/EscalatorReports';

const AuthenticatedApp = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const {user} = useSelector(s => s.user);
  const token = localStorage.getItem('token');

  const HIDE_NAVIGATION = ['_services_pdf'];

  useEffect(() => {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    dispatch(getMyProfile());
  }, []);

  return (
    <Box display="flex" minHeight="100vh">
      <ModalsManager />
      {!HIDE_NAVIGATION.some(path => location.pathname.includes(path)) && (
        <Navigation />
      )}
      <Box
        flex={1}
        minWidth={0}
        sx={
          !HIDE_NAVIGATION.some(path => location.pathname.includes(path)) && {
            mt: {xs: '56px', sm: '64px'},
          }
        }
        display="flex">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          {!!user?.role && user?.role === 'SUPERADMIN' && (
            <>
              <Route path="/admins" element={<Admins />} />
              <Route path="/admins/:id" element={<AdminDetails />} />
              <Route path="/supervisors" element={<Supervisors />} />
              <Route path="/supervisors/:id" element={<SupervisorsDetails />} />
              <Route path="/card/:id" element={<CardDetails />} />
              <Route path="/projects" element={<Complexes />} />
              <Route path="/projects/:id" element={<ComplexDetails />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/customers/:id" element={<CustomerDetails />} />
              <Route path="/elevators" element={<Elevators />} />
              <Route path="/elevators/:id" element={<ElevatorsDetails />} />
              <Route
                path="/elevators/view-reports"
                element={<ElevatorReports />}
              />
              <Route
                path="/escalators/view-reports"
                element={<EscalatorReports />}
              />
              <Route
                path="/elevators/add-elevator-report"
                element={<AddElevatorReport />}
              />
              <Route
                path="/escalators/add-escalator-report"
                element={<AddEscalatorReport />}
              />
              <Route path="/customers/new" element={<AddCustomer />} />
              <Route path="/customers/:id/add_card" element={<AddCard />} />
              <Route path="/entrances" element={<Entrances />} />
              <Route path="/entrances/:id" element={<EntranceDetails />} />
              <Route
                path="/elevators/:id/configure"
                element={<ElevatorConfigurations />}
              />
              <Route path="/profile" element={<Profile />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/services" element={<Services />} />
              <Route
                path="/services/add-elevator-report"
                element={<AddElevatorReport />}
              />
              <Route
                path="/services/add-escalator-report"
                element={<AddEscalatorReport />}
              />
              <Route
                path="/elevator_services_pdf"
                element={<PdfViewerScreen templateType="elevator" />}
              />
              <Route
                path="/escalator_services_pdf"
                element={<PdfViewerScreen templateType="escalator" />}
              />
              <Route path="*" element={<Navigate to="/" />} />
            </>
          )}
          {!!user?.role && user?.role === 'ADMIN' && (
            <>
              <Route path="/card/:id" element={<CardDetails />} />
              <Route path="/projects" element={<Complexes />} />
              <Route path="/projects/:id" element={<ComplexDetails />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/customers/:id" element={<CustomerDetails />} />
              <Route path="/elevators" element={<Elevators />} />
              <Route path="/elevators/:id" element={<ElevatorsDetails />} />
              <Route
                path="/elevators/view-reports"
                element={<ElevatorReports />}
              />
              <Route
                path="/escalators/view-reports"
                element={<EscalatorReports />}
              />
              <Route
                path="/elevators/add-elevator-report"
                element={<AddElevatorReport />}
              />
              <Route
                path="/escalators/add-escalator-report"
                element={<AddEscalatorReport />}
              />
              <Route path="/customers/new" element={<AddCustomer />} />
              <Route path="/customers/:id/add_card" element={<AddCard />} />
              <Route path="/entrances" element={<Entrances />} />
              <Route path="/entrances/:id" element={<EntranceDetails />} />
              <Route
                path="/elevators/:id/configure"
                element={<ElevatorConfigurations />}
              />
              <Route path="/profile" element={<Profile />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/services" element={<Services />} />
              <Route
                path="/services/add-elevator-report"
                element={<AddElevatorReport />}
              />
              <Route
                path="/services/add-escalator-report"
                element={<AddEscalatorReport />}
              />
              <Route
                path="/elevator_services_pdf"
                element={<PdfViewerScreen templateType="elevator" />}
              />
              <Route
                path="/escalator_services_pdf"
                element={<PdfViewerScreen templateType="escalator" />}
              />
              <Route path="*" element={<Navigate to="/" />} />
            </>
          )}

          {!!user?.role && user?.role === 'ELEVATOR_SUPERVISOR' && (
            <>
              <Route path="/elevators" element={<Elevators />} />
              <Route
                path="/elevators/view-reports"
                element={<ElevatorReports />}
              />
              <Route path="/elevators/:id" element={<ElevatorsDetails />} />
              <Route
                path="/elevators/add-elevator-report"
                element={<AddElevatorReport />}
              />
              <Route
                path="/elevator_services_pdf"
                element={<PdfViewerScreen templateType="elevator" />}
              />
              <Route path="/profile" element={<Profile />} />
              <Route path="*" element={<Navigate to="/elevators" />} />
            </>
          )}
        </Routes>
      </Box>
    </Box>
  );
};

export default AuthenticatedApp;
